import React, { useContext, useEffect } from 'react';
import './style.css';
import { Sidebar, Menu, MenuItem, useProSidebar } from 'react-pro-sidebar';
import { Box, Button, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/Home';
import Jobs from '@mui/icons-material/Work';
import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import Colors from '../../Constant/Colors';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { UserContextData } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export const RecruiterSidebar = () => {
  const navigate = useNavigate();
  const logout = () => {
    navigate('/login');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('User_Email');
    localStorage.removeItem('Role');
    localStorage.removeItem('user_id');
    localStorage.removeItem('recruiter');
    window.location.reload();
  };
  const Recruiter = JSON.parse(localStorage.getItem('recruiter'));
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/login');
    }
  }, []);
  console.log(Recruiter)
  return (
    <>
      <Box
        sx={{
          '& .pro-sidebar-inner': {
            background: `${Colors.primary} !important`,
          },
          '& .pro-icon-wrapper': {
            backgroundColor: 'transparent !important',
          },
          '& .pro-inner-item': {
            padding: '5px 35px 5px 20px !important',
          },
          '& .pro-inner-item:hover': {
            color: '#868dfb !important',
          },
          '& .pro-menu-item.active': {
            color: '#6870fa !important',
          },
          '& .ps-menu-button:hover': {
            backgroundColor: '#3f3d563b !important',
          },
          // backgroundColor:"#D4FEF8",
        }}>
        <Sidebar backgroundColor="white" style={{}}>
          <Menu iconShape="square">
            <Box mb="25px" mt="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                {Recruiter.profile_pic === null || Recruiter.profile_pic === '' ? (
                  <img
                    alt="Recruiter"
                    src={require('../../assets/Images/DefaultAvatar.jpg')}
                    style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <img
                    alt="Recruiter"
                    src={Recruiter.profile_pic}
                    style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>
              <Box textAlign="center">
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{ m: '10px 0 0 0' }}>
                  <Link to="/recruiter/dashboard/profile" style={{ textDecoration: 'none', color: Colors.primary }}>
                    {Recruiter && Recruiter.r_username}
                  </Link>
                </Typography>
              </Box>
            </Box>
            <Box mt="40px">
              {/* Menu Items     */}
              <MenuItem
                icon={<HomeOutlinedIcon />}
                component={<Link to={`/recruiter/dashboard/${Recruiter && Recruiter.recruiter_id}`} />}
                style={{
                  color: Colors.primary,
                  marginBottom: '10px',
                }}>
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{}}>
                  Home
                </Typography>
              </MenuItem>
              <MenuItem
                icon={<Jobs />}
                component={<Link to="/recruiter/dashboard/job-post" />}
                style={{
                  color: Colors.primary,
                  marginBottom: '10px',
                }}>
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{}}>
                  Job Post
                </Typography>
              </MenuItem>

              <MenuItem
                icon={<ReceiptOutlinedIcon />}
                component={<Link to="/recruiter/dashboard/job-applicants" />}
                style={{
                  color: Colors.primary,
                  marginBottom: '10px',
                }}>
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{}}>
                  Applicants
                </Typography>
              </MenuItem>

              {/* <MenuItem
                icon={<NotificationsIcon />}
                component={<Link to="/recruiter/dashboard" />}
                style={{
                  color: Colors.primary,
                  marginBottom: '10px',
                }}>
                <Typography
                  variant="h6"
                  color={Colors.primary}
                  fontWeight="bold"
                  sx={{}}>
                  Notifications
                </Typography>
              </MenuItem> */}
              <MenuItem
                icon={<Diversity1Icon />}
                component={<Link to="/recruiter/dashboard/connections" />}
                style={{
                  color: Colors.primary,
                  marginBottom: '10px',
                }}>
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{}}>
                  Connections
                </Typography>
              </MenuItem>

              <MenuItem
                icon={<SettingsIcon />}
                component={<Link to="/recruiter/dashboard/profile" />}
                style={{
                  color: Colors.primary,
                  marginBottom: '10px',
                }}>
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{}}>
                  Settings
                </Typography>
              </MenuItem>

              <MenuItem
                icon={<LogoutIcon />}
                onClick={() => logout()}
                style={{
                  color: Colors.primary,
                  marginTop: '110px',
                }}>
                <Typography variant="h6" color={Colors.primary} fontWeight="bold" sx={{}}>
                  Logout
                </Typography>
              </MenuItem>
            </Box>
          </Menu>
        </Sidebar>
      </Box>
    </>
  );
};
